import getCurrentMode from 'src/utils/currentMode/getCurrentMode';
import Vue from 'vue';
import isDevelopmentEnvironment from 'src/utils/developer/isDevEnvironment';
// import Tooltip from './components/Tooltip.vue'
import Tooltip from 'src/components/Tooltips/Tooltip.vue';
import ensureArray from 'src/utils/arrayOperations/ensureArray';
import arrayHasElements from 'src/utils/arrayOperations/arrayHasMembers';
// eslint-disable-next-line no-unused-vars
let vm; // gets assigned in created() as reference to 'this'
export default Vue.extend({
    components: { Tooltip },
    props: {
        title: { type: String },
        subtitle: { type: String },
        hideFullscreenButtonPassedThroughProps: { type: Boolean },
        hideCreateButtonPassedThroughProps: { type: Boolean },
        hideTopSlotButtonsProp: { type: Boolean },
        topRightCornerButtonsZoomPassedThroughProps: { type: Number },
        externalFilters: { type: Object },
        tableDatePickers: { type: Array },
        topSlotComponentsProp: { type: Array },
        ctx: { type: Object },
        additionalTableButtons: { type: Array },
        localFiltersAreSet: { type: Boolean },
        hideFiltersAreSetButtonPassedThroughProps: { type: Boolean },
        localFilterModelShownInTooltip: { type: String },
        creatingRecordsIsEnabled: { type: Boolean },
        createRecordShortcutDisabledPassedThroughProps: { type: Boolean },
        hideRefreshButtonPassedThroughProps: { type: Boolean },
        hideSaveViewButton: { type: Boolean },
        uploadingListIsEnabled: { type: Boolean },
        hideUploadListButtonPassedThroughProps: { type: Boolean },
        listUploadTemplateDownloadLink: { type: String },
        downloadListDialogueIsVisible: { type: Boolean },
        hideDownloadListButtonPassedThroughProps: { type: Boolean },
        hideTakeSnapshotButtonPassedThroughProps: { type: Boolean },
        hideColumnSelectorButtonPassedThroughProps: { type: Boolean },
        unconditionallyShowTheseColumnsInThisOrderPassedThroughProps: { type: Array },
        hideSortingModelButtonPassedThroughProps: { type: Boolean },
        localSortingModel: { type: Array },
        isFullscreen: { type: Boolean }
    },
    computed: {
        currentMode() { return getCurrentMode(); },
        isDevelopmentEnvironment() { return isDevelopmentEnvironment(); },
        additionalTableButtons_filtered() {
            const result = ensureArray(this.additionalTableButtons)
                .filter((tableButton) => {
                if (typeof tableButton.displayCondition === 'function')
                    return tableButton.displayCondition(this.ctx);
                if (typeof tableButton.displayCondition === 'boolean')
                    return tableButton.displayCondition;
                return true;
            });
            return result || [];
        },
        topSlotButtons() {
            const buttons = [];
            const featureIsEnabled = false;
            if (this.isDevelopmentEnvironment && featureIsEnabled) {
                buttons.push({
                    icon: 'mdi-developer-board',
                    clickHandler: () => { this.$emit('open-console'); },
                    tooltipContent: 'Open console'
                });
            }
            const savingViewsIsEnabled = true;
            if (savingViewsIsEnabled && !this.hideSaveViewButton) {
                buttons.push({
                    icon: 'mdi-table-plus',
                    clickHandler: () => { this.$emit('request-opening-save-table-view-dialog'); },
                    tooltipContent: 'Save as a view that will be available to you only'
                });
            }
            if (!this.hideDownloadListButtonPassedThroughProps) {
                buttons.push({
                    icon: 'mdi-arrow-collapse-down',
                    style: 'transform:scale(0.85)',
                    clickHandler: () => { this.$emit('download-list-dialogue-is-visible'); },
                    tooltipContent: 'Download the table as CSV file'
                });
            }
            if (!this.hideTakeSnapshotButtonPassedThroughProps) {
                buttons.push({
                    icon: 'mdi-content-cut',
                    style: 'transform:scale(0.85)',
                    clickHandler: () => { this.$emit('take-snapshot-of-main-table'); },
                    tooltipContent: 'Save snapshot of the table'
                });
            }
            if (!this.hideColumnSelectorButtonPassedThroughProps &&
                !this.unconditionallyShowTheseColumnsInThisOrderPassedThroughProps) {
                buttons.push({
                    icon: 'mdi-format-list-checkbox',
                    clickHandler: () => { this.$emit('column-selector-dialog-visible'); },
                    tooltipContent: 'Select columns'
                });
            }
            if (!this.hideSortingModelButtonPassedThroughProps && arrayHasElements(this.localSortingModel)) {
                buttons.push({
                    icon: 'mdi-sort',
                    clickHandler: () => { this.$emit('sorting-model-dialog-visible'); },
                    tooltipContent: 'Sorting model'
                });
            }
            if (!this.hideFullscreenButtonPassedThroughProps) {
                buttons.push({
                    icon: this.isFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen',
                    clickHandler: () => { this.$emit('toggle-full-screen'); },
                    tooltipContent: 'Toggle fullscreen'
                });
            }
            return buttons;
        }
    },
    created() {
        vm = this;
    },
    methods: {
        arrayHasElements,
        handleTableDatePickerInput({ inputEvent, tableDatePicker, isDateRange }) {
            if (!tableDatePicker.valueSetter)
                return;
            const popupsToHide = isDateRange
                ? undefined
                : (this.$refs['tableSingleDatePickerRef'] || [])[0] || this.$refs['tableSingleDatePickerRef'] || this.$refs['tableDatePickerRef'];
            tableDatePicker.valueSetter(inputEvent, this.ctx, popupsToHide);
        },
        openDirectLink(link) { window.open(link, '_blank'); }
    }
});
